import {FETCH_DICTIONARY_SUCCESS, FETCH_DEPENDENCY_SUCCESS} from "../actions/DictionaryActions";

const initialState = {
    service: [],
    deadline: {},
    price: {},
    additional: {},
    currency: {},
    phoneCodes: [],
    dependencies: {
        allowedExtensions: [],
        allowedMediaExtensions: [],
        needConvertFormats: [],
        sizeMin: {},
        sizeMax: {},
    },
};

export default function DictionaryReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_DICTIONARY_SUCCESS:
            return {...state, ...action.payload};

        case FETCH_DEPENDENCY_SUCCESS:
            return {
                ...state,
                dependencies: action.payload
            };
    }

    return state;
}
